import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from 'src/redux/store';
import { paths, subscriptionPaymentFailedTexts } from './config/TextMessage';
import { subscriptionPaymentFailedSx } from './CommomSxs';
import { UpgradePlanLiteModalSxs } from 'src/content/keywordResearch/keywordResearchCSS';



const SubscriptionPaymentFailed = () => {
  const navigate = useNavigate();
  const stripeSubscriptionDetails = useSelector(
    (state: RootState) => state.user.subscription
  );
  const stripeLoader =
    useSelector((state: RootState) => state.siteAudit.stripeLoader) ?? true;

  const isPaymentFailed =
    !stripeLoader &&
    stripeSubscriptionDetails?.payment_failed;    

  if (!isPaymentFailed) return null;

  return (
    <React.Fragment>
      <Box sx={subscriptionPaymentFailedSx.mainBox}>
        <Box sx={UpgradePlanLiteModalSxs?.headerBox}>
          <img
            style={UpgradePlanLiteModalSxs?.img}
            src={process.env.PUBLIC_URL + `/static/images/icons/alert-circle.svg`}
            alt="warning"
          />
          <Box>
            <Typography sx={subscriptionPaymentFailedSx.headerText}>
              {subscriptionPaymentFailedTexts.title}
            </Typography>
            <Typography sx={subscriptionPaymentFailedSx.desc}>
              {subscriptionPaymentFailedTexts.desc}
            </Typography>
          </Box>
        </Box>
        <Box sx={subscriptionPaymentFailedSx.buttonBox}>
          <Button
            variant="contained"
            sx={subscriptionPaymentFailedSx.button}
            onClick={() => navigate(paths.billing)}
          >
            <Typography sx={subscriptionPaymentFailedSx.buttonText}>
              {subscriptionPaymentFailedTexts.updatePayment}
            </Typography>
          </Button>
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default SubscriptionPaymentFailed;
